import React,{Component}   from 'react';
//前言
import shouce1 from './assets/img/shouce1.jpg';

class Section0 extends Component {

    // showDrawer = (data) => {
    //     this.props.enclosureShow(data.target.id,data.target.title)
    // }

    render(){
        return(
            <div>
                <br/><br/>
                <img src={shouce1} alt="" style={{
                    width  : '500px',
                    display: 'block',
                    margin : '0 auto'}}/> 
                <br/><br/>
                <h2><strong>董事长致词:</strong></h2><br/>
                <div style={{ textIndent: '2em' }}>
                    <p>欢迎加入云豪集团，一个令你能将能力和潜力发挥到极致的平台。</p>
                    <p>“成功之始，人品为本”，优良的职业素养是一个人在职场上优秀品质的外在表达，云豪注重员工职业素养的培养与历练，我们为每一位员工提供自由展示的平台，勤奋努力自然会得到褒奖，消极怠慢毫无疑问会被淘汰！我们希望看到所有员工能在这个平台上实现自己的梦想。同时希望每一位员工都能做老板，至少是管理自己的老板。</p>
                    <p>云豪团队通过自己的努力不断实现一个又一个目标，这与团队的凝聚和付出密不可分。员工对企业的忠诚度是验证企业经营管理是否完善的标准之一,我感激并庆幸这二十年来一直和我并肩前行的战友们，我也渴望能有新的战友加入到我们的战斗团队里来，并能成为云豪大家庭的一员，能成为云豪学院的一员。</p>
                    <p>宪法是神圣不可侵犯的，企业的规章制度也是所有员工必须遵守的，云豪亦然。在《员工手册》面前云豪不会偏袒任何人，因为任何一项规章制度都是云豪人共同建立的，《员工手册》需要受到所有云豪人的尊重和保护。</p>
                    <p>从今天起，我们将凝聚在一起，共同走向人生的另一高度，每个人在云豪的日子里都会和谐、快乐，有所收获！</p>
                    <p></p>
                    <br/><br/>
                    <h4 style={{
                        textAlign: 'right',
                        padding  : '0 100px 0 0'
                    }}> 董事长：王云厅</h4>
                    <br/><br/>
                    <br/><br/>
                    <br/><br/>
                </div>
                {/*
                <div><strong style={{color:'#6699FF'}}>附件：</strong><a type="primary" id='Enclosure0_1' title="《云豪集团安全生产事故（事件）处理规则》" onClick={(value)=>this.showDrawer(value)}>《云豪集团安全生产事故（事件）处理规则》</a></div>
                <div><strong style={{color:'#6699FF'}}>附件：</strong><a type="primary" id='Enclosure0_2' title="《云豪集团安全生产事故（事件）处理规则》" onClick={(value)=>this.showDrawer(value)}>《云豪集团安全生产事故（事件）处理规则》</a></div>
               */}
            </div>
        )
    }
}

export default Section0;